<template>
	<div class="pa-6">
		<v-card>
			<v-card-title>
				<p class="headline">
					Бюджет {{ hotelName }}, {{ period }}
				</p>
			</v-card-title>

			<v-card-text>
				<v-row justify="space-between">
					<v-col class="body-2" cols="12" >Текущая версия</v-col>

					<v-col cols="12" sm="6" md="4">
						<v-list dense>
							<v-list-item>
								<v-list-item-content>
									Номер
								</v-list-item-content>
								<v-list-item-content class="align-end">
									{{ +lastVer ? lastVer : '' }}
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content>
									Статус
								</v-list-item-content>
								<v-list-item-content class="align-end">
									{{ textStatus(status) }}
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content>
									Выручка
								</v-list-item-content>
								<v-list-item-content class="align-end">
									{{ revenue }}
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content>
									GOP
								</v-list-item-content>
								<v-list-item-content class="align-end">
									{{ gop }}
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</v-col>

					<!-- <v-col class="grow" ></v-col> -->

					<v-col cols="12" sm="6" md="4">
						<v-row >
							<v-col cols="5" class="pa-2">
								<v-btn-toggle
									v-model="formatTglHeader"
									class="elevation-1"
									mandatory>
									<v-btn small>
										PDF
									</v-btn>
									<v-btn small>
										XLS
									</v-btn>
								</v-btn-toggle>
							</v-col>
							<v-col cols="7"  class="pa-2">
								<v-menu offset-y left>
									<template v-slot:activator="{ on }">
										<v-btn
											small block light
											v-on="on"
											:disabled="!+lastVer"
										>
											Скачать бюджет
										</v-btn>
									</template>
									<v-list dense>
										<v-list-item @click="combine({
											reportCode: 'pl_bud_ver',
											origin: 'header',
											type: 1,
											ver: lastVer
										})">
											<v-list-item-title>Финансовые показатели</v-list-item-title>
										</v-list-item>
										<v-list-item @click="combine({
											reportCode: 'pl_bud_ver',
											origin: 'header',
											type: 2,
											ver: lastVer
										})">
											<v-list-item-title>Метрики</v-list-item-title>
										</v-list-item>
										<v-list-item
											v-if="lastVer > 1"
											@click="combine({
												reportCode: 'pl_bud_ver_vs_ver',
												origin: 'header',
												type: 1,
												ver_a: lastVer - 1,
												ver_b: lastVer
											})">
											<v-list-item-title>Сравнение с предыдущей версией</v-list-item-title>
										</v-list-item>
									</v-list>
								</v-menu>
							</v-col>
							<v-col cols="12"  class="pa-2">
								<v-menu offset-y>
									<template v-slot:activator="{ on }">
										<v-btn
											small block light
											:disabled="!+lastVer"
											v-on="on"
										>
											Скачать другие файлы
										</v-btn>
									</template>
									<v-list dense>
										<v-list-item
											v-if="lastVersion.files.own"
											@click="getFile(lastVersion.files.own, lastVersion.ver)">
											<v-list-item-title>Формат владельца</v-list-item-title>
										</v-list-item>
										<v-list-item
											v-if="lastVersion.files.doc"
											@click="getFile(lastVersion.files.doc, lastVersion.ver)">
											<v-list-item-title>Описательная часть</v-list-item-title>
										</v-list-item>
										<v-list-item
											v-if="lastVersion.files.pre"
											@click="getFile(lastVersion.files.pre, lastVersion.ver)">
											<v-list-item-title>Презентация</v-list-item-title>
										</v-list-item>
										<v-divider></v-divider>
										<v-list-item
											v-for="file in lastVersion.files.oth"
											:key="file.serverName"
											@click="getFile(file, lastVersion.ver)">
											<v-list-item-title>{{ file.name }}</v-list-item-title>
										</v-list-item>
									</v-list>
								</v-menu>
							</v-col>
						</v-row>
					</v-col>

					<!-- <v-col class="grow" ></v-col> -->

					<v-col cols="12" md="4">
						<a-status-table
							:steps="steps"
							:status="+status"
						></a-status-table>
					</v-col>


					<v-col class="body-2" cols="12" >История версий</v-col>
				</v-row>
			</v-card-text>

			<v-data-table
				:headers="headers"
				:items="versions"
				:items-per-page="-1"
				hide-default-footer
				:no-data-text="loading ? 'Загрузка...' : 'Ни одной версии пока не загружено'"
				item-key="ver"
				disable-sort
				:mobile-breakpoint="0"
				show-expand
				single-expand
				:expanded.sync="expanded"
				@click:row="clickRow">
				<template v-slot:item.status="props">
					{{ textStatus(props.item.status) }}
				</template>
				<template v-slot:expanded-item="props">
					<td :colspan="props.headers.length" class="pa-0">
						<v-card tile dark >
							<v-card-text>
								<v-row class="ma-0">
									<v-col cols="12" sm="6" md="8">
										<p>
											Загрузил: {{ props.item.reportedBy }}
										</p>
										<p>
											Комментарии: {{ props.item.comment }}
										</p>
									</v-col>
									<v-col cols="12" sm="6" md="4">
										<v-row >
											<v-col cols="5" class="pa-2">
												<v-btn-toggle v-model="formatTglTable" mandatory class="elevation-1" >
													<v-btn text small>
														PDF
													</v-btn>
													<v-btn text small>
														XLS
													</v-btn>
												</v-btn-toggle>
											</v-col>
											<v-col cols="7" class="pa-2">
												<v-menu offset-y left>
													<template v-slot:activator="{ on }">
														<v-btn
															small block color="primary"
															v-on="on"
														>
															Скачать бюджет
														</v-btn>
													</template>
													<v-list dense>
														<v-list-item @click="combine({
															reportCode: 'pl_bud_ver',
															origin: 'table',
															type: 1,
															ver: props.item.ver
														})">
															<v-list-item-title>Финансовые показатели</v-list-item-title>
														</v-list-item>
														<v-list-item @click="combine({
															reportCode: 'pl_bud_ver',
															origin: 'table',
															type: 2,
															ver: props.item.ver
														})">
															<v-list-item-title>Метрики</v-list-item-title>
														</v-list-item>
														<v-list-item
															v-if="props.item.ver > 1"
															@click="combine({
																reportCode: 'pl_bud_ver_vs_ver',
																origin: 'table',
																type: 1,
																ver_a: props.item.ver - 1,
																ver_b: props.item.ver
															})">
															<v-list-item-title>Сравнение с предыдущей версией</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
											</v-col>
											<v-col cols="12" class="pa-2">
												<v-menu offset-y>
													<template v-slot:activator="{ on }">
														<v-btn
															small block color="primary"
															v-on="on"
															:disabled="!props.item.files.own
																&& !props.item.files.doc
																&& !props.item.files.pre
																&& !props.item.files.oth.length"
														>
															Скачать другие файлы
														</v-btn>
													</template>
													<v-list dense>
														<v-list-item
															v-if="props.item.files.own"
															@click="getFile(props.item.files.own, props.item.ver)">
															<v-list-item-title>Формат владельца</v-list-item-title>
														</v-list-item>
														<v-list-item
															v-if="props.item.files.doc"
															@click="getFile(props.item.files.doc, props.item.ver)">
															<v-list-item-title>Описательная часть</v-list-item-title>
														</v-list-item>
														<v-list-item
															v-if="props.item.files.pre"
															@click="getFile(props.item.files.pre, props.item.ver)">
															<v-list-item-title>Презентация</v-list-item-title>
														</v-list-item>
														<v-divider></v-divider>
														<v-list-item
															v-for="file in props.item.files.oth"
															:key="file.serverName"
															@click="getFile(file, props.item.ver)">
															<v-list-item-title>{{ file.name }}</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
											</v-col>
											<v-col cols="12" v-if="allowUpdateVersion(props.item)">
												<v-btn
													small block color="primary"
													@click="updateVersion">
													Редактировать эту версию
												</v-btn>
											</v-col>
										</v-row>
									</v-col>
								</v-row>

							</v-card-text>
						</v-card>
					</td>
				</template>
			</v-data-table>

			<v-card-actions class="pl-4 mt-4">
				<v-btn
					small
					v-if="allowApprove"
					color="primary"
					:loading="loadingApprove"
					@click="approve">
					Согласовать
					<v-icon small color="green" class="ml-2">check_circle</v-icon>
				</v-btn>
				<v-btn
					small
					v-if="allowWithdraw"
					color="primary"
					:loading="loadingWithdraw"
					@click="withdraw">
					Отозвать решение
					<v-icon small color="red" class="ml-2">undo</v-icon>
				</v-btn>
				<v-btn
					small
					v-if="allowNewVersion"
					color="primary"
					@click="newVersion">
					Новая версия
				</v-btn>
				<v-btn
					small
					v-if="allowDelEntry"
					color="primary"
					@click="delEntry">
					Удалить этот бюджет
				</v-btn>
			</v-card-actions>

			<v-divider></v-divider>

			<v-card-text>
				<a-comments-block
					ref="comments"
					type="bud"
					:id="id"
					:allowFiles="false">
				</a-comments-block>
			</v-card-text>
		</v-card>
		<v-dialog v-model="dialog.show" max-width="800" persistent>
			<v-card tile>
				<v-card-title class="subtitle-1">Версия {{ dialog.ver }}</v-card-title>
				<v-card-text>
					<v-form ref="f" v-model="dialog.valid">
		            	<v-container>
		              		<v-row >
								<v-col cols="12">
									<p>
										Выберите файл формата csv для загрузки бюджета. Файл не должен содержать названий столбцов. Каждая строка файла должна содержать данные в следующем формате:
									</p>

									<p class="title font-weight-light">[год];[месяц];[код отдела];[код статьи];[сумма]</p>
								</v-col>
		                		<v-col cols="12">
									<a-file-picker
										v-model="csv"
										v-show="!dialog.csvLoaded"
										label="Выберите файл CSV"
										formats="csv"
										maxSize="3"
										required
									></a-file-picker>
		                		</v-col>
								<template v-if="dialog.csvLoaded">
									<v-col cols="12">
										<v-icon color="green" small>check_circle</v-icon>
										Файл прочитан, количество строк: {{ dialog.lines }}
									</v-col>
									<v-col cols="12">
										<v-text-field
											v-model="dialog.revenue"
											:loading="dialog.loading"
											readonly
											label="Выручка"
										></v-text-field>
										<v-text-field
											v-model="dialog.gop"
											:loading="dialog.loading"
											readonly
											label="GOP"
										></v-text-field>
										<v-textarea
											auto-grow
											filled
											:rules="[ v => +dialog.ver == 1 || !!v.length || 'Укажите, в чем отличия от предыдущей версии' ]"
											label="Комментарии к этой версии"
											v-model="dialog.comment"
										></v-textarea>
									</v-col>
			                		<v-col cols="12">
										<p>
											Приложите дополнительные файлы
										</p>
			                		</v-col>
			                		<v-col cols="7">
										<a-file-picker
											v-model="own"
											label="Бюджет в формате владельца (Excel)"
											formats="xls|xlsx"
											maxSize="10"
											:disabled="dialog.keep.own"
										></a-file-picker>
										<!-- :required="!dialog.keep.own" -->
			                		</v-col>
			                		<v-col cols="5">
										<v-checkbox
											v-model="dialog.keep.own"
											v-if="dialog.fileCopyVersion.ver"
											:disabled="!dialog.fileCopyVersion.files.own"
											:label="'Взять из версии '  + dialog.fileCopyVersion.ver">
										</v-checkbox>
			                		</v-col>
			                		<v-col cols="7">
										<a-file-picker
											v-model="doc"
											label="Описательная часть (Word)"
											formats="doc|docx"
											maxSize="10"
											:disabled="dialog.keep.doc">
										</a-file-picker>
										<!-- :required="!dialog.keep.doc" -->
			                		</v-col>
			                		<v-col cols="5">
										<v-checkbox
											v-model="dialog.keep.doc"
											v-if="dialog.fileCopyVersion.ver"
											:disabled="!dialog.fileCopyVersion.files.doc"
											:label="'Взять из версии '  + dialog.fileCopyVersion.ver">
										</v-checkbox>
			                		</v-col>
			                		<v-col cols="7">
										<a-file-picker
											v-model="pre"
											label="Презентация (Powerpoint / PDF)"
											formats="ppt|pptx|pdf"
											maxSize="10"
											:disabled="dialog.keep.pre">
										</a-file-picker>
										<!-- :required="!dialog.keep.pre" -->
			                		</v-col>
			                		<v-col cols="5">
										<v-checkbox
											v-model="dialog.keep.pre"
											v-if="dialog.fileCopyVersion.ver"
											:disabled="!dialog.fileCopyVersion.files.pre"
											:label="'Взять из версии '  + dialog.fileCopyVersion.ver">
										</v-checkbox>
			                		</v-col>
			                		<v-col cols="7">
										<a-file-picker
											v-model="oth"
											label="Другие файлы"
											maxSize="10"
											:disabled="dialog.keep.oth"
											multiple>
										</a-file-picker>
			                		</v-col>
			                		<v-col cols="5">
										<v-checkbox
											v-model="dialog.keep.oth"
											v-if="dialog.fileCopyVersion.ver"
											:disabled="!dialog.fileCopyVersion.files.oth.length"
											:label="'Взять из версии '  + dialog.fileCopyVersion.ver">
										</v-checkbox>
			                		</v-col>
								</template>
		              		</v-row>
		            	</v-container>
					</v-form>
				</v-card-text>

		        <v-card-actions>
					<v-btn
						text
						v-if="!dialog.csvLoaded"
						@click="loadCsv"
						:loading="dialog.loading"
						:disabled="!dialog.valid">
						Загрузить
					</v-btn>
					<v-btn
						text
						v-else
						@click="submitVersion"
						:loading="dialog.loading">
						Отправить
					</v-btn>
		            <v-btn text @click="close">Отмена</v-btn>
		        </v-card-actions>
        	</v-card>
		</v-dialog>
	</div>
</template>

<style scoped>
	.nowrap {
		white-space: nowrap;
	}
</style>

<script>
	import {c} from '../../../lib/const'
	import {api} from '../../../lib/api'
	import {display} from '../../../lib/display'
	import {getMonthName} from '../../../js/common.js'
	import _ from 'lodash'
	import aStatusTable from '../../base/AStatusTable.vue'
	import aFilePicker from '../../base/AFilePicker.vue'
	import aCommentsBlock from '../../base/ACommentsBlock.vue'

	export default {
		components: {
			aStatusTable,
			aFilePicker,
			aCommentsBlock
		},
		data: () => ({
			id: 0,
			hotelCode: '',
			hotelName: '',
			revenue: '',
			gop: '',
			yearStart: 0,
			yearEnd: 0,
			monStart: 0,
			monEnd: 0,
			period: '',
			status: 0,
			loading: false,
			loadingApprove: false,
			loadingWithdraw: false,
			formatTglHeader: 0,
			formatTglTable: 0,
			versions: [],
			lastVer: 0,
			headers: [
				{
					text: 'Номер версии',
					value: 'ver',
					align: 'center',
				},
				{
					text: 'Дата отправки',
					value: 'reportedOn',
					align: 'center',
				},
				{
					text: 'Выручка',
					value: 'revenue',
					align: 'center',
				},
				{
					text: 'GOP',
					value: 'gop',
					align: 'center',
				},
				{
					text: 'Статус',
					value: 'status',
					align: 'center',
				},
			],
			steps: [
				{
					status: 0,
					name: 'Согласование FC'
				},
				{
					status: 1,
					name: 'Согласование GM'
				},
				{
					status: 6,
					name: 'Согласование УК'
				},
				{
					status: 8,
					name: 'Согласование владельцем'
				},
			],
			dialog: {
				show: false,
				update: false,
				valid: false,
				ver: '',
				csvLoaded: false,
				revenue: '',
				gop: '',
				comment: '',
				lines: 0,
				lastVersion: null,
				keep: {
					own: false,
					doc: false,
					pre: false,
					oth: false
				},
			},
			timer: 0,
			expanded: [],
			csv: [],
			own: [],
			doc: [],
			pre: [],
			oth: [],
			updateInterval: 60000 // 1 минута
		}),
		computed: {
			lastVersion() {
				if (this.versions.length) return this.versions[this.versions.length - 1]
				else return {
					files: {
						own: null,
						doc: null,
						pre: null,
						oth: []
					},
					ver: ''
				}
			},
			secondLastVersion() {
				if (this.versions.length > 1) return this.versions[this.versions.length - 2]
				else return {
					files: {
						own: null,
						doc: null,
						pre: null,
						oth: []
					},
					ver: ''
				}
			},
			formatHeader() {
				return +this.formatTglHeader ? 'xls' : 'pdf'
			},
			formatTable() {
				return +this.formatTglTable ? 'xls' : 'pdf'
			},
			allowDelEntry() {
				// return this.versions.length == 0 || this.$store.getters.userHasRight('delete_budgets')
				return this.$store.getters.userHasRight('delete_budgets')
			},
			allowApprove() {
				if (this.status == c.PL_STATUS_INITIAL
					&& this.$store.getters.userHasRight('pl_input')
				) {
					return true
				}
				else if (this.status == c.PL_STATUS_FC_REPORTED
					&& this.$store.getters.userHasRight('pl_approve')
				) {
					return true
				}
				else if (this.status == c.PL_STATUS_GM_APPROVED
					&& this.$store.getters.userHasRight('pl_ho_approve')
				) {
					return true
				}
				else if (this.status == c.PL_STATUS_HO_APPROVED
					&& this.$store.getters.userHasRight('pl_owner_approve')
				) {
					return true
				}
				else return false
			},
			allowWithdraw() {
				if (this.status == c.PL_STATUS_FC_REPORTED
					&& this.$store.getters.userHasRight('pl_input')
				) {
					return true
				}
				else if (this.status == c.PL_STATUS_GM_APPROVED
					&& this.$store.getters.userHasRight('pl_approve')
				) {
					return true
				}
				else if (this.status == c.PL_STATUS_HO_APPROVED
					&& this.$store.getters.userHasRight('pl_ho_approve')
				) {
					return true
				}
				else if (this.status == c.PL_STATUS_FINAL
					&& this.$store.getters.userHasRight('pl_owner_approve')
				) {
					return true
				}
				else return false
			},
			allowNewVersion() {
				return this.$store.getters.userHasRight('pl_input')
			},
		},
		created() {
		},
		mounted() {
			this.id = +this.$route.params.id
			this.loadData()

			this.timer = setInterval(() => {
				if (!document.hidden) {
					this.loadData()
				}
			}, this.updateInterval)

			window.onfocus = () => {
				this.loadData()
			}
		},
		destroyed() {
			clearInterval(this.timer)
		},
		methods: {
			clickRow (row) {
				let i = this.expanded.indexOf(row)
				if (i >= 0) {
					this.expanded.splice(i, 1)
				}
				else {
					this.expanded = []
					this.expanded.push(row)
				}
			},
			combine(args) {
				display.open({
					reportCode: args.reportCode,
					userId: this.$store.getters.userId,
					hotelCode: this.hotelCode,
					dept: 0,
					bud_entry: this.id,
					bud_ver: args.ver,
					bud_ver_a: args.ver_a,
					bud_ver_b: args.ver_b,
					yearStart: this.yearStart,
					yearEnd: this.yearEnd,
					monStart: this.monStart,
					monEnd: this.monEnd,
					format: args.origin == 'table' ? this.formatTable : this.formatHeader,
					type: args.type,
					unit: 1000,
					showNullLines: false,
					showInitialData: true,
					showPercent: false,
					lan: this.$store.getters.prefLan
				})
			},
			loadCsv() {
				this.$store.dispatch('dialogLoadingStart')
				var formData = new FormData()
				formData.append('csv', this.csv[0])
				formData.append('form', JSON.stringify({
					id: this.id
				}))

				api.post('pl/budget/check_csv', formData)
				.then(response => {
					this.$store.dispatch('dialogLoadingStop')

					this.dialog.lines = response.data.lines
					this.dialog.revenue = response.data.revenue
					this.dialog.gop = response.data.gop
					this.dialog.csvLoaded = true

				}, error => {
					this.$store.dispatch('dialogLoadingStop')
				})
			},
			newVersion() {
				if (this.$refs.f != undefined) this.$refs.f.resetValidation()
				this.csv = []

				this.dialog = {
					show: true,
					update: false,
					valid: false,
					ver: +this.lastVer + 1,
					csvLoaded: false,
					revenue: '',
					gop: '',
					comment: '',
					lines: 0,
					fileCopyVersion: this.lastVersion,
					keep: {
						own: false,
						doc: false,
						pre: false,
						oth: false
					},
				}
			},
			submitVersion() {
				if (!this.$refs.f.validate()) return

				this.$store.dispatch('dialogLoadingStart')

				var formData = new FormData()
				formData.append('csv', this.csv[0])
				formData.append('own', this.own[0])
				formData.append('doc', this.doc[0])
				formData.append('pre', this.pre[0])

				let l = this.oth.length
				for (let i = 0; i < l; i++) {
					formData.append('oth[]', this.oth[i])
				}

				formData.append('form', JSON.stringify({
					id: this.id,
					update: this.dialog.update,
					comment: this.dialog.comment,
					keep: this.dialog.keep
				}))

				api.post('pl/budget/add_version', formData)
				.then(response => {
					this.$store.dispatch('dialogLoadingStop')

					this.dialog.show = false

					// this.updateComments = true
					// this.$refs.comments.load()

					this.loadData()

				}, error => {
					this.$store.dispatch('dialogLoadingStop')
				})
			},
			close() {
				this.dialog.show = false
			},
			delEntry() {
				this.$store.dispatch('dialogConfirm', {
					title: 'Подтверждение',
					message: 'Это действие удалит все версии данного бюджета безвозвратно'
				})
				.then(confirm => {
					if (confirm) {
						api.post('pl/budget/del_entry', {
							id: this.id,
						})
						.then(response => {
							this.$router.push('list')
						}, error => {})
					}
				})
			},
			allowUpdateVersion(item) {
				return item.ver == this.lastVer && this.allowNewVersion && item.status == c.PL_STATUS_INITIAL && +item.editable
			},
			updateVersion() {
				if (this.$refs.f != undefined) this.$refs.f.resetValidation()
				this.csv = []

				this.dialog = {
					show: true,
					update: true,
					valid: false,
					ver: +this.lastVer,
					csvLoaded: false,
					revenue: '',
					gop: '',
					comment: '',
					lines: 0,
					fileCopyVersion: this.secondLastVersion,
					keep: {
						own: false,
						doc: false,
						pre: false,
						oth: false
					},
				}
			},
			textStatus(status) {
				if (!status) return 'Согласование FC'
				if (status == c.PL_STATUS_INITIAL) return 'Согласование FC'
				if (status == c.PL_STATUS_FC_REPORTED) return 'Согласование GM'
				if (status == c.PL_STATUS_GM_APPROVED) return 'Согласование УК'
				if (status == c.PL_STATUS_HO_APPROVED) return 'Согласование владельцем'
				if (status == c.PL_STATUS_FINAL) return 'Финальная'
				if (status == c.PL_STATUS_OUTDATED) return 'Версия устарела'
			},
			loadData() {
				this.loading = true
				// this.updateComments = true
				this.$refs.comments.load()

				// console.log('loading data')

				api.post('pl/budget/get_entry', {
					id: this.id,
				})
				.then(response => {

					this.versions = response.data.versions
					this.lastVer = response.data.lastVer
					this.hotelCode = response.data.hotelCode
					this.hotelName = response.data.hotelName
					this.period = response.data.period
					this.yearStart = response.data.yearStart
					this.yearEnd = response.data.yearEnd
					this.monStart = response.data.monStart
					this.monEnd = response.data.monEnd
					this.status = response.data.status
					this.revenue = response.data.revenue
					this.gop = response.data.gop

					this.loading = false
				}, error => {})
			},
			getFile(file, ver) {
				if (file) window.open(api.path() + 'file.php?n=bd' + file.serverName + '&ver=' + ver)
			},
			approve() {
				this.loadingApprove = true
				api.post('pl/budget/approve', {
					id: this.id,
				})
				.then(response => {

					this.versions = response.data.versions
					this.lastVer = response.data.lastVer
					this.hotelCode = response.data.hotelCode
					this.hotelName = response.data.hotelName
					this.period = response.data.period
					this.yearStart = response.data.yearStart
					this.yearEnd = response.data.yearEnd
					this.monStart = response.data.monStart
					this.monEnd = response.data.monEnd
					this.status = response.data.status
					this.revenue = response.data.revenue
					this.gop = response.data.gop

					this.loadingApprove = false

					// this.updateComments = true
					this.$refs.comments.load()

					if (!response.data.approved) {
						this.$store.dispatch('dialogNotify', {
							title: 'Упс',
							message: 'Пока вы нажимали на кнопку, заявка изменила статус. Согласование невозможно.'
						})
					}
				}, error => {})
			},
			withdraw() {
				this.loadingWithdraw = true
				api.post('pl/budget/withdraw', {
					id: this.id,
				})
				.then(response => {

					this.versions = response.data.versions
					this.lastVer = response.data.lastVer
					this.hotelCode = response.data.hotelCode
					this.hotelName = response.data.hotelName
					this.period = response.data.period
					this.yearStart = response.data.yearStart
					this.yearEnd = response.data.yearEnd
					this.monStart = response.data.monStart
					this.monEnd = response.data.monEnd
					this.status = response.data.status
					this.revenue = response.data.revenue
					this.gop = response.data.gop

					this.loadingWithdraw = false

					// this.updateComments = true
					this.$refs.comments.load()

					if (!response.data.withdrawed) {
						this.$store.dispatch('dialogNotify', {
							title: 'Упс',
							message: 'Пока вы нажимали на кнопку, заявка изменила статус. Отзыв невозможен.'
						})
					}
				}, error => {})
			},
		}
	}
</script>
